import React, { useCallback, useMemo, useState } from 'react';
import * as Styles from './UpgradeSitebuilder.styles';
import {
  Button,
  Checkbox,
  IconData,
  IconLoading,
  Select,
} from 'gatorcomponents';
import { V2Forms } from '@/hooks/supportForms/useSupportForms.types';
import useLocale from '@/hooks/useLocale/useLocale';
import { HgProducts } from '../../SupportForms.types';

export const UpgradeSitebuilder = ({
  selectedProduct,
  opening,
  submitForm,
}) => {
  const { ticket: ticketsLocale } = useLocale();
  const { upgradeSiteBuilder: upgradeSiteBuilderLocale } = ticketsLocale.forms;
  const [newProduct, setNewProduct] = useState(null);
  const [agreed, setAgreed] = useState(null);

  const checkForm = useCallback(() => {
    let isOk = false;

    isOk = newProduct
      && agreed;

    return !isOk;
  }, [
    newProduct,
    agreed,
  ]);

  const getProductsOptions = useMemo(() => {
    const products = [];

    const higherThanProfessional = [
      HgProducts.WEB_HOSTING_CREADOR_DE_SITIOS_PROFESIONAL,
      HgProducts.WEB_HOSTING_CREADOR_DE_SITIOS_TIENDA_EN_LINEA,
    ].includes(selectedProduct.pid);

    if (!higherThanProfessional) {
      products.push({
        label: upgradeSiteBuilderLocale.placeholders.professional,
        value: upgradeSiteBuilderLocale.placeholders.professional,
      });
    }

    const isTienda = [HgProducts.WEB_HOSTING_CREADOR_DE_SITIOS_TIENDA_EN_LINEA].includes(selectedProduct.pid);
    if (!isTienda) {
      products.push({
        label: upgradeSiteBuilderLocale.placeholders.tienda,
        value: upgradeSiteBuilderLocale.placeholders.tienda,
      });
    }

    return products;
  }, [selectedProduct, upgradeSiteBuilderLocale]);

  const handleSubmit = useCallback((e) => {
    e.preventDefault();

    const data = {
      locale: ticketsLocale,
      automation: false,
      pid: selectedProduct.pid,
      product: selectedProduct.id,
      subject: ticketsLocale.forms.names.upgradeSiteBuilder,
      key: V2Forms.UPGRADE_SITEBUILDER,
      tags: [
        'whmcs_form_financiero_upgrade-downgrade_plan',
        selectedProduct.name.toLowerCase().replace(/ /g, '_'),
      ],
      body: `
        ${upgradeSiteBuilderLocale.body.product(selectedProduct)}
        ${upgradeSiteBuilderLocale.body.request}
        ${upgradeSiteBuilderLocale.body.newProduct(newProduct)}
        ${upgradeSiteBuilderLocale.body.agreed(agreed)}
        ${upgradeSiteBuilderLocale.body.productId(selectedProduct)}
        `,
    };

    submitForm && submitForm(data);
  }, [
    ticketsLocale,
    upgradeSiteBuilderLocale,
    submitForm,
    selectedProduct,
    newProduct,
    agreed,
  ]);

  return (
    <Styles.Form onSubmit={e => handleSubmit(e)}>
      <Styles.Info>
        <IconData />
        {upgradeSiteBuilderLocale.info}
      </Styles.Info>

      <Styles.Title>
        {upgradeSiteBuilderLocale.title}
      </Styles.Title>

      <Styles.InputsWrapper>
        <Select
          testId="newProduct"
          placeholder={upgradeSiteBuilderLocale.placeholders.newPlan}
          label={newProduct ? upgradeSiteBuilderLocale.placeholders.newPlan : ''}
          options={getProductsOptions}
          value={newProduct}
          setValue={label => setNewProduct(label)}
          withScroll
        />

        <Styles.CheckboxLabel
          htmlFor="#agreedTerms"
          data-testid="agreedTerms"
          onClick={() => setAgreed(!agreed)}
        >
          <Checkbox checked={agreed} id="checkAgreedTerms" />
          <Styles.Text>
            {upgradeSiteBuilderLocale.placeholders.agreed}
          </Styles.Text>
        </Styles.CheckboxLabel>
      </Styles.InputsWrapper>

      <Styles.ButtonWrapper>
        <Button
          size="large"
          label={opening ? <IconLoading /> : upgradeSiteBuilderLocale.send}
          disabled={checkForm() || opening}
          type="submit"
          testId="submit"
        />
      </Styles.ButtonWrapper>
    </Styles.Form>
  );
};

export default UpgradeSitebuilder;
